<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormCanEndInspection
      :CanEndInspection="editCanEndInspection"
      :isSaving="isSaving"
      :isCompleted="isCompleted"
      :stockItem="stockItem"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormCanEndInspection from '../components/FormCanEndInspection.vue';
import checklist from './checklist';
import stockItem from './stockItem';

export default {
  components: {
    FormCanEndInspection,
  },
  name: 'EditCanEndInspection',
  module: 'CanEndInspection',
  mixins: [checklist, loading, stockItem],
  data() {
    return {
      /**
      * Get/Set editing CanEndInspection. Default to {}.
      */
      editCanEndInspection: {},
      /**
       * Query Id for CanEndInspection
       */
      canEndInspectionId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('canEndInspections', ['canEndInspections', 'canEndInspection']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.stockItem?.canEndInspections.length > 0) {
        return 'edit';
      }
      return 'add';
    },
  },
  destroyed() {
    this.$off('stockItem.loaded');
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      if (item.canEndInspections?.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.editCanEndInspection = item.canEndInspections[0];
        this.isCompleted = true;
      } else {
        this.editCanEndInspection.stockItemId = item.id;
        this.editCanEndInspection.supplier = item.deliveryNote.farm.name;
        this.editCanEndInspection.date = this.formatDate(new Date());
        // this.editCanEndInspection.seamerUsed = 'SOMME 550';
      }
      this.$log.info('Prepopulation completed');
      this.$forceUpdate();
    });
    this.isLoading = true;
    // if (this.mode === 'edit') {
    //   await this.LOAD_canEndInspection(this.canEndInspectionId);
    //   this.editCanEndInspection = this.canEndInspection;
    // }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canEndInspections', ['LOAD_canEndInspection', 'CREATE_canEndInspection', 'UPDATE_canEndInspection']),
    /** Method used to save the item
     */
    async save(canEndInspection) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_canEndInspection(canEndInspection);
      } else {
        await this.UPDATE_canEndInspection(canEndInspection);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditCanEndInspection example

'''js
<EditCanEndInspection :CanEndInspection="CanEndInspection" />
'''
</docs>
